// export const deskData = [
//   { value: "1", name: "1" },
//   { value: "2", name: "2" },
//   { value: "3", name: "3" },
//   { value: "4", name: "4" },
//   { value: "5", name: "5" },
//   { value: "6", name: "6" },
//   { value: "7", name: "7" },
//   { value: "8", name: "8" },
//   { value: "9", name: "9" },
//   { value: "10", name: "10" },
// ];

// const deskPrinterData = [
//   { desk: "1", printer: "71193307" },
//   { desk: "2", printer: "71193307" },
//   { desk: "3", printer: "71193307" },
//   { desk: "4", printer: "71193307" },
//   { desk: "5", printer: "71193307" },
//   { desk: "6", printer: "71193307" },
//   { desk: "7", printer: "71193307" },
//   { desk: "8", printer: "71193307" },
//   { desk: "9", printer: "71193307" },
//   { desk: "10", printer: "71193307" },
// ];

export const selectPrinterByDesk = (printerList, desk) => {
  let printer = "";
  for (let i in printerList) {
    let data = printerList[i];
    if (data.deskNumber === desk) {
      printer = data.printerId;
      break;
    }
  }
  return printer;
};
